<template>
  <div
    class="popup-box bg-white dark:bg-dark-blue absolute z-[10000] grid border border-gray-300 dark:border-light-purple-bar/[.4] rounded-md w-max right-[0px] top-[100%] shadow-xl"
  >
    <slot></slot>
  </div>
</template>
